import { ProductDetailsPage } from './product-details-page';
import { HomePage } from './home-page';
import { CollectionsPage } from './collections-page';

export type { PreviewData } from './preview.types';

export const Preview = {
  ProductDetailsPage,
  HomePage,
  CollectionsPage,
};
